import React, { FC } from 'react';
import Icon from 'carbon-react/lib/components/icon';

import { FormattedMessage } from '@futrli/localisation';

import { InformativeDatasourceStatusMessage } from '../informative-datasource-status-message/informative-datasource-status-message';

export const NoDataError: FC = () => (
  <InformativeDatasourceStatusMessage
    icon={<Icon type="warning" fontSize="extra-large" />}
    title={
      <FormattedMessage id="predict.something_lost" defaultMessage="Looks like something got lost along the way!" />
    }
    body={
      <FormattedMessage
        id="predict.unable_to_see_data_contact_support"
        defaultMessage="We are unable to see your data right now. Please contact support so we can put this right."
      />
    }
    showContactSupport={true}
  />
);
